import { createFileRoute } from '@tanstack/react-router';
import { ProfilePage } from '@/pages/Cabinet/Profile';

export const Route = createFileRoute('/_layout/cabinet/profile')({
  component: ProfilePage,
});
